import React from 'react';
import {Link} from 'react-router-dom';
import {FormGroup, Label, Input, FormFeedback, Button} from 'reactstrap';

import {IPCaptcha, CaptchaAlternativeLink} from 'components/Captcha';
import FormPost from 'components/Forms/FormBases/FormPost';
import {REGEXP} from 'configs';
import useLoginEmail from './useLoginEmail';
import useLoginCaptcha from './useLoginCaptcha';
import MuiIcon from 'components/Icons/MuiIcon';

function LoginEmail(props) {
  const {onNext} = props;
  const {isLoading, loginEmail} = useLoginEmail(onNext);
  const {isVerifying, verifyCaptcha, captchaSession, setCaptchaSession} =
    useLoginCaptcha();

  return (
    <React.Fragment>
      <div className="text-center">
        <h1>Log in</h1>
        <p className="text-muted">
          Don't you have account yet? <Link to="/register">Sign up here</Link>
        </p>
      </div>

      <FormPost
        submit={false}
        onSubmit={(data) => {
          if (data['g-recaptcha-response']) delete data['g-recaptcha-response'];

          loginEmail({...data, captcha_session_id: captchaSession});
        }}
        isSubmitting={isLoading}
      >
        <fieldset disabled={isLoading}>
          <FormGroup>
            <Label>
              Email Address <span className="text-danger">*</span>
            </Label>
            <Input
              type="email"
              name="email"
              placeholder="Email Address"
              autoComplete="off"
              pattern={REGEXP.email}
              required
            />
            <FormFeedback>
              Please enter a valid email address. Ex: example@yahoo.com
            </FormFeedback>
          </FormGroup>

          <FormGroup className="d-flex justify-content-center">
            <IPCaptcha
              onVerify={verifyCaptcha}
              onExpire={() => setCaptchaSession(null)}
            />
          </FormGroup>
        </fieldset>

        <Button
          block
          type="submit"
          disabled={isLoading || !captchaSession || isVerifying}
          color="primary"
        >
          {isLoading ? (
            'Submitting...'
          ) : (
            <span className="d-flex align-items-center justify-content-center">
              Continue <MuiIcon name="chevron_right" />
            </span>
          )}
        </Button>
      </FormPost>

      <div className="mt-4 text-center">
        <CaptchaAlternativeLink />
      </div>
    </React.Fragment>
  );
}

export default LoginEmail;
